import React from 'react';
import { Platform, Dimensions } from 'react-native';
import { TitleBarAndMenu } from './TitleBarAndMenu';
import RightToastMessage from '../RightToastMessage';
import DashboardMessages from '../DashboardMessages';
import { TitleTabBar } from './TitleTabBar';

const { width } = Dimensions.get('window');
const isMobileWeb = width <= 550 && Platform.OS === 'web';

const LEFT_CONTENT_WIDTH = 680;

export function GridLayoutWithRightContent(props) {
  return (
    <div className='full-height'>
      <TitleBarAndMenu {...props} />
      <RightToastMessage />
      <DashboardMessages />
      <div className='grid-x full-height content-top-padding'>
        <div
          className='cell medium-5 large-4 white overflow-y'
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: `${isMobileWeb ? '100%' : `${LEFT_CONTENT_WIDTH}px`}`,
          }}
        >
          {props.children}
          <div className='show-for-small-only' style={{ display: 'flex' }}>
            <TitleTabBar {...props} />
          </div>
        </div>
        <div
          className='cell medium-7 large-7 medium-cell-block-y overflow-y'
          id='right-content'
          style={{
            width: `calc(100% - ${LEFT_CONTENT_WIDTH}px)`,
          }}
        />
      </div>
    </div>
  );
}
